import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import { FormContainer, PasswordRepeatElement, useForm } from 'react-hook-form-mui';
import ValidatedTextField from '../Utilities/Forms/ValidatedTextField';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router';
import { APIContext } from '../Contexts/APIContext';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { TextField } from '@mui/material';

export default function RegisterUser() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const token = query.get('token');
    const userId = query.get('user');

    const { post, get, showMessage, loading, getPDF } = useContext(APIContext);
    const navigate = useNavigate();
    const [agree, setAgree] = useState<boolean>(false);
    const [agree2, setAgree2] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [userName, setUserName] = useState('');


    useEffect(() => {
        get("AdminUser", `GetUsernameFromId?id=${userId}`, setUserName);
        if (!token || !userId) {
            navigate('/authorisation/login');
        }
    }, [token, userId]);

    const handleResetPassword = async (form: any) => {

        form.token = token;
        form.id = userId;
        await post('AdminUser', 'ActivateAccount', form, (success: boolean) => {
            showMessage('success', 'Password successfully set.');
            navigate('/authorisation/login');
        });
    };

    const getFile = () => {
        getPDF(
            'Document',
            `GetLibraryFile?folder=GeneralDocs&fileName=TRICS User Licence Agreement %28Terms %26 Conditions%29`,
            `TRICS User Licence Agreement Terms & Conditions`,
            true
        );
    };

    const formContext = useForm({
        defaultValues: { password: '' },
    });

    return (
        <FormContainer
            formContext={formContext}
            onSuccess={handleResetPassword}
        >
            <Grid container>
                <Grid size={12}>
                    <Typography variant="h4" textAlign="center">New User Registration</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography variant="body1">
                        Please enter your password below.
                    </Typography>
                </Grid>
                <Grid size={6}>
                    <ValidatedTextField label="First Name" name='firstName' />
                </Grid>
                <Grid size={6}>
                    <ValidatedTextField label="Last Name" name='lastName' />
                </Grid>
                <Grid size={12}>
                    <TextField label="Email" autoComplete="username" name='email' value={userName} disabled />
                </Grid>
                <Grid size={12}>
                    <ValidatedTextField label="Password" name='password' type='password' />
                </Grid>
                <Grid size={12}>
                    <PasswordRepeatElement label="Confirm Password" name='password-repeat' passwordFieldName='password' size='small' fullWidth />
                </Grid>
                <Grid size={12}>
                    <FormControlLabel label="I agree to TRICS Intellectual Property Rights"
                        control={
                            <Checkbox checked={agree} onChange={(e, checked) => setAgree(checked)} color="primary" />
                        }
                    />
                </Grid>
                <Grid size={12}>
                    <FormControlLabel label="I agree to TRICS User Licence Agreement Terms & Conditions"
                        control={
                            <Checkbox checked={agree2} onChange={(e, checked) => setAgree2(checked)} color="primary" />
                        }
                    />
                </Grid>
                <Grid size={12}>
                    <Button variant="text" size="small" onClick={() => setOpen(true)}>Click here to view the TRICS Intellectual Property Rights.</Button>
                </Grid>
                <Grid size={12}>
                    <Button variant="text" size="small" onClick={getFile}>Click here to view the TRICS User Licence Agreement Terms & Conditions.</Button>
                </Grid>
                <Grid size={12}>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading || !agree || !agree2}
                    >
                        Submit
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogTitle>Intellectual Property Rights</DialogTitle>
                <DialogContent>
                    <Typography>
                        The survey data, graphs and all associated supporting information, contained within the TRICS Database are created and published by TRICS Consortium Limited ("the Company") and the Company claims copyright and database rights in this published work. Use of this data is restricted to current TRICS licence holders and those using the TRICS Bureau Service. Licence holders may publish data from the TRICS Database in accordance with the TRICS licence. TRICS data, or extracts of TRICS data, should only be provided to third parties as part of a complete planning application document or in accordance with the Company's Bureau Services or the members' terms of licence. Data should not be attained by copying extracts from previously published reports or other documents. Any use, publication or distribution of data owned by the Company, whether obtained from the TRICS Database or from third party operated planning portals, without the Company's authorisation or a valid TRICS licence (other than in accordance with the Company's Bureau Service), will infringe the Company's intellectual property rights in the data. Please be aware that any unauthorised use of data contained in online planning portals may constitute a breach of the third party's terms of use and/or an infringement of its intellectual property rights.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </FormContainer>
    );
}
